/* ============================================================
   KEPT — homepage interactions
   Scroll reveal, parallax, marquee and the sticky nav, ported
   from the original design and scoped per Shopify section so
   each one can be toggled independently in the Theme Editor.
   ============================================================ */
(function () {
  'use strict';

  /* The snippet that loads this file is rendered by every KEPT section, so the
     same <script src> can appear more than once. Fetching is de-duped by the
     browser; this guard de-dupes execution. */
  if (window.__keptBooted) return;
  window.__keptBooted = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var root = document.documentElement;
  var announceH = 0;
  var io = null;
  var pars = [];
  var ticking = false;
  var listening = false;

  function flag(el, name) {
    return el && el.dataset[name] !== 'false';
  }

  /* The announcement bar sits above the fixed nav and changes height when it
     wraps, so its height drives both the hero height and the nav offset.
     The custom property is written to <html> and to every .kept root, because
     the design system declares a fallback on .kept which would otherwise
     shadow the value inherited from the document root. */
  function measure() {
    var ann = document.querySelector('[data-kept-announce]');
    announceH = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
    var value = announceH + 'px';
    root.style.setProperty('--kept-announce-h', value);
    document.querySelectorAll('.kept').forEach(function (el) {
      el.style.setProperty('--kept-announce-h', value);
    });
    return announceH;
  }

  function show(el) {
    if (el.dataset.revealed) return;
    el.dataset.revealed = '1';
    var sibs = Array.prototype.slice.call(
      el.parentElement.querySelectorAll(':scope > [data-reveal]')
    );
    el.style.transitionDelay = Math.min(Math.max(sibs.indexOf(el), 0), 4) * 90 + 'ms';
    el.classList.remove('is-armed');
    el.classList.add('is-revealed');
    if (io) io.unobserve(el);
  }

  function collectReveal() {
    var armed = [];

    document.querySelectorAll('[data-kept-motion]').forEach(function (host) {
      var on = flag(host, 'keptReveal') && !reduce.matches;
      host.querySelectorAll('[data-reveal]').forEach(function (el) {
        if (!on) {
          el.classList.remove('is-armed');
          el.classList.add('is-revealed');
          el.dataset.revealed = '1';
          return;
        }
        if (el.dataset.revealed) return;
        el.classList.add('is-armed');
        armed.push(el);
      });
    });

    return armed;
  }

  function initReveal() {
    var armed = collectReveal();
    if (io) io.disconnect();
    if (!armed.length) return;

    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) show(e.target); });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    armed.forEach(function (el) { io.observe(el); });

    /* Fail-safe: the observer only fires on threshold crossings, so sweep for
       anything already on screen that never produced an entry. */
    function sweep() {
      var pending = 0;
      armed.forEach(function (el) {
        if (el.dataset.revealed) return;
        pending++;
        if (el.getBoundingClientRect().top < window.innerHeight * 0.94) show(el);
      });
      if (!pending) {
        window.removeEventListener('scroll', sweep);
        window.removeEventListener('resize', sweep);
      }
    }
    requestAnimationFrame(sweep);
    setTimeout(sweep, 400);
    window.addEventListener('scroll', sweep, { passive: true });
    window.addEventListener('resize', sweep, { passive: true });
  }

  function initMarquee() {
    document.querySelectorAll('[data-kept-marquee]').forEach(function (track) {
      var host = track.closest('[data-kept-motion]');
      var on = flag(host, 'keptReveal') && !reduce.matches;
      var secs = parseFloat(track.dataset.keptMarquee) || 60;
      track.style.animationDuration = secs + 's';
      track.style.animationPlayState = on ? 'running' : 'paused';
    });
  }

  function onScroll() {
    var nav = document.querySelector('[data-kept-header]');
    if (nav) {
      /* Ride the fixed nav down over the announcement bar, then pin it at 0. */
      nav.style.top = Math.max(0, announceH - window.scrollY) + 'px';
      nav.classList.toggle('is-solid', window.scrollY > window.innerHeight * 0.72);
    }

    if (!ticking && pars.length) {
      ticking = true;
      requestAnimationFrame(function () {
        var vh = window.innerHeight;
        pars.forEach(function (el) {
          var box = el.parentElement.getBoundingClientRect();
          if (box.bottom < -200 || box.top > vh + 200) return;
          var p = (box.top + box.height / 2 - vh / 2) / vh;
          el.style.transform =
            'translate3d(0,' + (-p * parseFloat(el.dataset.par) * vh).toFixed(1) + 'px,0)';
        });
        ticking = false;
      });
    }
  }

  function initParallax() {
    pars = [];
    if (reduce.matches) return;
    document.querySelectorAll('[data-kept-motion]').forEach(function (host) {
      if (!flag(host, 'keptParallax')) return;
      host.querySelectorAll('[data-par]').forEach(function (el) { pars.push(el); });
    });
  }

  function boot() {
    if (!document.querySelector('.kept')) return;
    measure();
    initMarquee();
    initReveal();
    initParallax();
    if (!listening) {
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
      listening = true;
    }
    onScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', function () { measure(); onScroll(); });
  if (reduce.addEventListener) reduce.addEventListener('change', boot);

  /* Theme Editor swaps sections in and out of the DOM live. */
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', boot);
  document.addEventListener('shopify:section:reorder', boot);
  document.addEventListener('shopify:section:select', boot);
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target.closest('[data-reveal]') || e.target.querySelector('[data-reveal]');
    if (el) { el.dataset.revealed = '1'; el.classList.add('is-revealed'); el.classList.remove('is-armed'); }
  });
})();
